export var FilterDataTypeEnum;
(function (FilterDataTypeEnum) {
    FilterDataTypeEnum["String"] = "string";
    FilterDataTypeEnum["Date"] = "date";
    FilterDataTypeEnum["Value"] = "value";
    FilterDataTypeEnum["Multiple"] = "multiple";
    FilterDataTypeEnum["Amount"] = "amount";
    FilterDataTypeEnum["Boolean"] = "boolean";
})(FilterDataTypeEnum || (FilterDataTypeEnum = {}));
